import { Box, Modal, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Slider from "@mui/material/Slider";
import { variableContext } from "../../context/VariableContex";
const style = {
  width: "100%",
  display: "flex",
  padding: "2px 0px",
  borderRadius: "12px",
  justifyContent: "flex-start",
  gap: "0px",
  alignItems: "center",
};

function SliderModal() {
  const { setLocationFilter, locationData } = useContext(variableContext);

  const [value, setValue] = useState(10);

  const handleChange = (e, value) => {
    setValue(value);
  };

  const handleChangeCommitted = (e, value) => {
    setLocationFilter('radius', value);
  };

  useEffect(() => {
    setValue(locationData?.radius ?? 200);
  }, [locationData]);

  return (
    <Box style={style}>
      <Slider
        value={value}
        aria-label="Default"
        valueLabelDisplay="auto"
        min={10}
        max={200}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        sx={{
          width: "78%",
          color: "#1a5fa8",
          "& .MuiSlider-rail": {
            height: "3px",
            backgroundColor: "#c8d8e8",
          },
          "& .MuiSlider-track": {
            height: "3px",
          },
          "& .MuiSlider-thumb": {
            height: "18px",
            width: "18px",
            backgroundColor: "#2d3a4a",
            border: "2px solid #fff",
            boxShadow: "0 0 0 3px rgba(45,58,74,0.25)",
            "&:after": {
              width: "28px !important",
              height: "28px !important",
            },
          },
        }}
      />
      <Typography sx={{ color: "#333", marginLeft: "11px", flexShrink: 0, fontSize: "14px", fontWeight: 500 }}>{`${value} Kms`}</Typography>
    </Box>
  );
}

export default SliderModal;
